// there a few places where we need to get the parent/product (collection, set, article)
// and the hand at the same time so good to have this a reusable hook
import { useQuery } from '@apollo/client';
import {
  handQueries
} from '../graphql/queries';
import { convertLangCodeToGraphqlEnum } from '../helpers/locale.js';

export default function useHandAndParentQuery ({ handId, parentId, language, parentQuery }) {
  const { data: handData, loading: handLoading } = useQuery(handQueries.HandById, {
    variables: {
      id: handId
    }
  });
  const { data: parentData, loading: parentLoading } = useQuery(parentQuery, {
    variables: {
      id: parentId,
      language: convertLangCodeToGraphqlEnum(language)
    }
  });

  // Return null ONLY while loading. Once settled — resolved-with-null, or errored so the
  // data is undefined (a bad/missing id or language) — hand back the responses so callers
  // can tell "not found" from "still loading" and render a fallback instead of a blank page.
  if (handLoading || parentLoading) {
    return null;
  }

  return {
    handData,
    parentData
  };
}
